import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, MapPin } from 'lucide-react';
const NAMES = ['María', 'Laura', 'Carolina', 'Sofía', 'Valentina', 'Camila', 'Florencia', 'Ana', 'Lucía', 'Martina'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'Tucumán', 'Neuquén'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      triggerPopup();
    }, 5000);
    // Loop
    const interval = setInterval(() => {
      triggerPopup();
    }, Math.random() * 15000 + 15000); // Random between 15-30s
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  const triggerPopup = () => {
    const name = NAMES[Math.floor(Math.random() * NAMES.length)];
    const city = CITIES[Math.floor(Math.random() * CITIES.length)];
    setCurrentBuyer({
      name,
      city
    });
    setIsVisible(true);
    // Hide after 4 seconds
    setTimeout(() => {
      setIsVisible(false);
    }, 4000);
  };
  return <AnimatePresence data-id="element-81">
      {isVisible && <motion.div initial={{
      x: -100,
      opacity: 0,
      y: 50
    }} animate={{
      x: 0,
      opacity: 1,
      y: 0
    }} exit={{
      x: -100,
      opacity: 0,
      y: 50
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-4 left-4 z-40 bg-white rounded-lg shadow-xl p-4 max-w-xs border-l-4 border-[#9CAF88] flex items-center gap-3" data-id="element-82">
          <div className="bg-[#9CAF88]/10 p-2 rounded-full" data-id="element-83">
            <CheckCircle2 className="text-[#9CAF88]" size={24} data-id="element-84" />
          </div>
          <div data-id="element-85">
            <p className="text-sm font-bold text-gray-800" data-id="element-86">
              {currentBuyer.name} acaba de comprar
            </p>
            <div className="flex items-center gap-1 text-xs text-gray-500" data-id="element-87">
              <MapPin size={10} data-id="element-88" />
              <span data-id="element-89">{currentBuyer.city}, Argentina</span>
            </div>
            <p className="text-xs text-[#9CAF88] font-medium mt-1" data-id="element-90">
              Yoga Esencial
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}